import ProRatedUpgradeContainer from './ProRatedUpgradeContainer';

export default ProRatedUpgradeContainer;
